import React, { useState } from "react";
import { FaCaretDown, FaCaretUp } from "react-icons/fa";
import moment from "moment";

export default function SessionLogCard({ log }) {
  const [show, setShow] = useState();
  return (
    <div>
      <div
        className="flex my-3 pb-2 border-b border-b-[#BBBBBB] justify-between px-3 items-center cursor-pointer"
        onClick={() => setShow(!show)}
      >
        <h4 className="text-[14px] font-poppin font-medium">
          {log.sessionType}
        </h4>
        <div className="flex items-center">
          <h4 className="text-[14px] font-poppin font-medium">
            {moment(log.date).format("MMM Do YY")}
          </h4>
          {show ? (
            <FaCaretDown
              className="ml-2 text-[16px] cursor-pointer"
              onClick={() => setShow(!show)}
            />
          ) : (
            <FaCaretUp className="ml-2 text-[16px] cursor-pointer" />
          )}
        </div>
      </div>
      {show && (
        <div className="border-b border-b-[#BBBBBB] px-2 pb-2">
          <div className="flex justify-between mb-2">
            <div className="flex items-center">
              <p className="text-[12px] font-poppin">
                {moment(log.timeStart).format("h:mm a")}
              </p>
              <p className="font-poppin mx-1">-</p>
              <p className="text-[12px] font-poppin">
                {moment(log.timeStart).format("h:mm a")}
              </p>
            </div>
            <p className="text-[12px] font-poppin font-bold">{log.duration}</p>
          </div>
          <p className="text-[12px] font-poppin">{log.notes}</p>
        </div>
      )}
    </div>
  );
}
